'use client';

import { useAuth } from '@clerk/clerk-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type AttemptTransition, transitionAttempt } from '@/lib/admin/client';
import { taskStatusPrefixKey } from '@/lib/admin/queryKeys';

export type AttemptTransitionVariables = {
  attemptId: string;
  transition: AttemptTransition;
};

export function useAttemptTransition() {
  const { getToken, userId, sessionId } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      attemptId,
      transition,
    }: AttemptTransitionVariables) => {
      const token = await getToken();
      if (!token) throw new Error('Missing auth token');
      return transitionAttempt(token, attemptId, transition);
    },
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: taskStatusPrefixKey({ userId, sessionId }),
      }),
  });
}
